import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { GridModule } from "@progress/kendo-angular-grid";
import { PopoverModule } from "ngx-popover";
import { PipesModule } from "../../../../shared/_pipes/pipes.module";
import { DirectivesModule } from "../../../directives/directives.module";
import { ContactsComponent } from "./contacts.component";
import { ContactService } from "./contacts.service";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        PipesModule,
        DirectivesModule,
        PopoverModule,
        GridModule
    ],
    declarations: [
        ContactsComponent
    ],
    exports: [
        ContactsComponent
    ],
    providers: [
        ContactService
    ]
})
export class ContactsModule { }
